import request from "../utils/request"
export function station(data) {
  return request({
    url: '/service/mg/follower/query-list-by-category-code',
    method: 'post',
    data
  })
}
export function list(data) {
  return request({
    url: '/service/mg/user/list',
    method: 'post',
    data
  })
}
export function add(data) {//新增员工
  return request({
    url: '/service/mg/user',
    method: 'post',
    data
  })
}
export function edit(data) {//修改员工
  return request({
    url: '/service/mg/user',
    method: 'put',
    data
  })
}
export function status(data) {//修改状态
    return request({
        url: '/service/mg/user/status',
        method: 'put',
        data
    })
}

export function postMenus() { // 获取登录用户的菜单
    return request({
        url: '/service/mg/public/user/menus',
        method: 'POST',
    })
}

export function postUserMenus(data) { // 获取 新增员工时的 全部菜单
    return request({
        url: '/service/mg/user/menus',
        method: 'POST',
        data
    })
}

export function postMenusRedPoint() { // 获取 小红点统计
    return request({
        url: '/service/mg/public/user/red-point',
        method: 'POST',
    })
}

export function postSaveOrUpdate(data) { // 修改菜单权限
    return request({
        url: '/service/mg/user/menus/saveOrUpdate',
        method: 'POST',
        data,
    })
}
// 用户所拥有的按钮权限code
export function getAuthButton() {
    return request({
        url: '/service/mg/public/user/button',
        method: 'POST',
    })
}
//http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8319
export function getUserExtra(data) {
    return request({
        url: '/service/mg/public/user/getUserInfo',
        method: 'POST',
        data
    })
}